import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SCRIPT_SRC = "https://widget-cdn.simplepractice.com/assets/integration-1.0.js";

/**
 * Loads and re-runs the SimplePractice integration script after each
 * client-side navigation, so newly-mounted booking buttons get bound.
 *
 * The script's top-level IIFE binds any element with [data-spwidget-autobind]
 * once when it executes. By removing and re-appending the script tag on each
 * pathname change, we trigger that bind step for the current page's buttons.
 */
export default function SimplePracticeLoader() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Wait a tick so React finishes rendering the booking buttons.
    const id = window.setTimeout(() => {
      // Remove any existing SP integration script so the new one re-runs.
      document
        .querySelectorAll(`script[data-sp-integration="true"]`)
        .forEach((s) => s.remove());

      const s = document.createElement("script");
      s.src = SCRIPT_SRC;
      s.async = true;
      s.dataset.spIntegration = "true";
      document.body.appendChild(s);
    }, 50);

    return () => window.clearTimeout(id);
  }, [pathname]);

  return null;
}
